import Vue from "vue";
import VueRouter from "vue-router";
import cookies from "vue-cookies";
import index from "../views/home";
import login from "../views/login";
const hall = () => import("../views/hall/hall");
const modifyEmail = () => import("../views/personalCenter/modifyEmail"); //修改邮箱
const bindEmail = () => import("../views/personalCenter/bindEmail"); //绑定邮箱
const modifyPhone = () => import("../views/personalCenter/modifyPhone"); //修改手机号
const changePassword = () => import("../views/personalCenter/changePassword"); //修改密码
const bindPhone = () => import("../views/personalCenter/bindPhone"); //绑定手机号
const taskHall = () => import("../views/taskViews/taskHall"); //任务大厅
const taskDetail = () => import("../views/taskViews/taskDetail");
const myTask = () => import("../views/taskViews/myTask");
const forget = () => import("../views/forget"); //忘记密码
const realName = () => import("../views/personalCenter/realName.vue"); // 实名认证
const bankCard = () => import("../views/personalCenter/bankCard.vue"); // 绑定银行卡
const personalCenter = () =>
  import("../views/personalCenter/personalCenter.vue"); // 个人中心
const accounts = () => import("../views/personalCenter/accounts.vue"); // 个人中心下的账户安全
const userInfo = () => import("../views/personalCenter/userInfo.vue"); // 个人中心下的个人信息
const userBio = () => import("../views/personalCenter/userBio.vue"); // 个人中心的 个人简历
const authenticationK1 = () =>
  import("../views/authentication/authenticationK1.vue"); // K1认证
const authenticationK6 = () =>
  import("../views/authentication/authenticationK6.vue"); // K6认证
const authenticationState = () =>
  import("../views/authentication/authenticationState.vue"); // 认证状态
const languageSelectionK1 = () =>
  import("../views/authentication/languageSelectionK1.vue"); // 语言选择 K1
const languageSelectionK6 = () =>
  import("../views/authentication/languageSelectionK6.vue"); // 语言选择 K6
const passCertification = () =>
  import("../views/authentication/passCertification.vue"); // 认证通过K1
const certificationAudit = () =>
  import("../views/authentication/certificationAudit.vue"); // 认证审核K1
const domainList = () => import("../views/authentication/domainList.vue"); // 领域列表
const examination = () => import("../views/authentication/examination.vue"); // 试卷页面
const result = () => import("../views/authentication/result.vue"); // 试卷结果页面
const orderList = () => import("../views/taskViews/orderList"); // 旧任务详情
const taskOrder = () => import("../views/taskViews/taskOrder"); // 任务详情
const messageCenter = () => import("../views/personalCenter/messageCenter"); // 任务详情
const myIntegral = () => import("../views/personalCenter/myIntegral"); // 我的积分
const myGrade = () => import("../views/personalCenter/myGrade"); // 我的等级
const myIncome = () => import("../views/personalCenter/myIncome"); // 我的收入
const ruleManagement = () =>
  import("../views/footerFileAll/ruleManagement.vue"); // 译员服务规则及管理制度
const serviceAgreement = () =>
  import("../views/footerFileAll/serviceAgreement.vue"); // 服务协议
const legalPrivacy = () => import("../views/footerFileAll/legalPrivacy.vue"); // 法律声明及隐私权政策
const contactUs = () => import("../views/footerFileAll/contactUs.vue"); // 联系我们
const about = () => import("../views/footerFileAll/about.vue"); // 关于我们
const helpCenter = () => import("../views/footerFileAll/helpCenter.vue"); // 帮助中心
const registerAndLogin = () =>
  import("../views/footerFileAll/heIpCenterAll/registerAndLogin.vue"); // 帮助中心 注册登录
const nameAuthentication = () =>
  import("../views/footerFileAll/heIpCenterAll/nameAuthentication.vue"); // 帮助中心 实名认证
const fillInTheResume = () =>
  import("../views/footerFileAll/heIpCenterAll/fillInTheResume.vue"); // 帮助中心 填写简历
const becomeAnInterpreter = () =>
  import("../views/footerFileAll/heIpCenterAll/becomeAnInterpreter.vue"); // 帮助中心 成为译员
// const languageTesting = () =>
//   import("../views/footerFileAll/heIpCenterAll/languageTesting.vue"); // 帮助中心 等级测试
// const interpreterCategory = () =>
//   import("../views/footerFileAll/heIpCenterAll/interpreterCategory.vue"); // 帮助中心 译员类别
const interpreterGrade = () =>
  import("../views/footerFileAll/heIpCenterAll/interpreterGrade.vue"); // 帮助中心 译员等级
const getTask = () =>
  import("../views/footerFileAll/heIpCenterAll/getTask.vue"); // 帮助中心 领取任务
const missionName = () =>
  import("../views/footerFileAll/heIpCenterAll/missionName.vue"); // 帮助中心 任务名称
// const manuscript = () =>
//   import("../views/footerFileAll/heIpCenterAll/manuscript.vue"); // 帮助中心 交稿改稿
const escalationRule = () =>
  import("../views/footerFileAll/platformRulesAll/escalationRule.vue"); // 帮助中心 升级规则
// const taskRule = () =>
//   import("../views/footerFileAll/platformRulesAll/taskRule.vue"); // 帮助中心 任务规则
const punishmentStandard = () =>
  import("../views/footerFileAll/platformRulesAll/punishmentStandard.vue"); // 帮助中心 惩罚标准
const qualityStandard = () =>
  import("../views/footerFileAll/platformRulesAll/qualityStandard.vue"); // 帮助中心 惩罚标准
const commonProblem = () =>
  import("../views/footerFileAll/heIpCenterAll/commonProblem.vue"); // 帮助中心 常见问题
const platformRules = () =>
  import("../views/footerFileAll/heIpCenterAll/platformRules.vue"); // 帮助中心 常见问题
//招募
const recruitDetail = () => import("../views/recruit/recruitDetail.vue"); //招募详情
const recruitList = () => import("../views/recruit/recruitList.vue"); //招募表
const contract = () => import("../views/recruit/contract.vue"); //临时文件 签约译员介绍
// 资讯
const topicDoc = () => import("../views/realTime/topicDoc");
const category = () => import("../views/realTime/category");
const labelgroup = () => import("../views/realTime/labelgroup");
const realInfo = () => import("../views/realTime/realInfo");
const moveAbout = () => import("../views/realTime/moveAbout");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/index",
    name: "index",
    component: index,
  },
  {
    path: "/contract",
    name: "contract",
    component: contract,
  },
  {
    path: "/login",
    name: "login",
    component: login,
  },
  // 资讯-专题
  {
    path: "/topicDoc/:id",
    name: "topicDoc",
    component: topicDoc,
  },
  // 资讯-栏目
  {
    path: "/category",
    name: "category",
    component: category,
  },
  // 资讯-标签get文章
  {
    path: "/labelgroup/:tag",
    name: "labelgroup",
    component: labelgroup,
  },
  // 资讯-详情
  {
    path: "/realInfo/:id",
    name: "realInfo",
    component: realInfo,
  },
  // 资讯-详情
  {
    path: "/moveAbout/:id",
    name: "moveAbout",
    component: moveAbout,
  },
  {
    path: "/forget",
    name: "forget",
    component: forget,
  },
  {
    path: "/changePassword",
    name: "changePassword",
    component: changePassword,
    meta: {
      auth: true, // 用于判断当前路由是否需要登陆
    },
  },
  {
    path: "/taskHall",
    name: "taskHall",
    component: taskHall,
    meta: {
      auth: true, // 用于判断当前路由是否需要登陆
    },
  },
  {
    path: "/messageCenter",
    name: "messageCenter",
    component: messageCenter,
  },
  {
    path: "/recruitDetail",
    name: "recruitDetail",
    component: recruitDetail,
    meta: {
      auth: true, // 用于判断当前路由是否需要登陆
    },
  },
  {
    path: "/recruitList",
    name: "recruitList",
    component: recruitList,
    meta: {
      auth: true, // 用于判断当前路由是否需要登陆
    },
  },
  {
    path: "/hall",
    name: "hall",
    component: hall,
    meta: {
      auth: true, // 用于判断当前路由是否需要登陆
    },
    children: [
      {
        path: "/taskDetail",
        name: "taskDetail",
        component: taskDetail,
        meta: {
          auth: true, // 用于判断当前路由是否需要登陆
        },
      },
      {
        path: "/myTask",
        name: "myTask",
        component: myTask,
        meta: {
          auth: true, // 用于判断当前路由是否需要登陆
        },
      },
      {
        path: "/orderList",
        name: "orderList",
        component: orderList,
        meta: {
          auth: true, // 用于判断当前路由是否需要登陆
        },
      },
      {
        path: "/taskOrder",
        name: "taskOrder",
        component: taskOrder,
        meta: {
          auth: true, // 用于判断当前路由是否需要登陆
        },
      },
    ],
  },
  {
    path: "/realName",
    name: "realName",
    component: realName,
    meta: {
      auth: true, // 用于判断当前路由是否需要登陆
    },
  },
  {
    path: "/bankCard",
    name: "bankCard",
    component: bankCard,
    meta: {
      auth: true, // 用于判断当前路由是否需要登陆
    },
  },

  {
    path: "/personalCenter",
    name: "personalCenter",
    component: personalCenter,
    meta: {
      auth: true, // 用于判断当前路由是否需要登陆
    },
    children: [
      {
        path: "/myGrade",
        name: "myGrade",
        component: myGrade,
        meta: {
          auth: true, // 用于判断当前路由是否需要登陆
        },
      },
      {
        path: "/myIncome",
        name: "myIncome",
        component: myIncome,
        meta: {
          auth: true, // 用于判断当前路由是否需要登陆
        },
      },
      {
        path: "/myIntegral",
        name: "myIntegral",
        component: myIntegral,
        meta: {
          auth: true, // 用于判断当前路由是否需要登陆
        },
      },
      {
        path: "/accounts",
        name: "accounts",
        component: accounts,
        meta: {
          auth: true, // 用于判断当前路由是否需要登陆
        },
      },
      {
        path: "/userInfo",
        name: "userInfo",
        component: userInfo,
        meta: {
          auth: true, // 用于判断当前路由是否需要登陆
        },
      },
      {
        path: "/userBio",
        name: "userBio",
        component: userBio,
        meta: {
          auth: true, // 用于判断当前路由是否需要登陆
        },
      },
    ],
  },
  {
    path: "/modifyEmail",
    name: "modifyEmail",
    component: modifyEmail,
    meta: {
      auth: true, // 用于判断当前路由是否需要登陆
    },
  },
  {
    path: "/bindEmail",
    name: "bindEmail",
    component: bindEmail,
    meta: {
      auth: true, // 用于判断当前路由是否需要登陆
    },
  },
  {
    path: "/modifyPhone",
    name: "modifyPhone",
    component: modifyPhone,
    meta: {
      auth: true, // 用于判断当前路由是否需要登陆
    },
  },
  {
    path: "/bindPhone",
    name: "bindPhone",
    component: bindPhone,
    meta: {
      auth: true, // 用于判断当前路由是否需要登陆
    },
  },
  {
    path: "/authenticationK1",
    name: "authenticationK1",
    component: authenticationK1,
    meta: {
      auth: true, // 用于判断当前路由是否需要登陆
    },
  },
  {
    path: "/authenticationK6",
    name: "authenticationK6",
    component: authenticationK6,
    meta: {
      auth: true, // 用于判断当前路由是否需要登陆
    },
  },
  {
    path: "/authenticationState",
    name: "authenticationState",
    component: authenticationState,
    meta: {
      auth: true, // 用于判断当前路由是否需要登陆
    },
  },

  {
    path: "/languageSelectionK1",
    name: "languageSelectionK1",
    component: languageSelectionK1,
    meta: {
      auth: true, // 用于判断当前路由是否需要登陆
    },
  },
  {
    path: "/languageSelectionK6",
    name: "languageSelectionK6",
    component: languageSelectionK6,
    meta: {
      auth: true, // 用于判断当前路由是否需要登陆
    },
  },
  {
    path: "/passCertification",
    name: "passCertification",
    component: passCertification,
    meta: {
      auth: true, // 用于判断当前路由是否需要登陆
    },
  },
  {
    path: "/certificationAudit",
    name: "certificationAudit",
    component: certificationAudit,
    meta: {
      auth: true, // 用于判断当前路由是否需要登陆
    },
  },
  {
    path: "/domainList",
    name: "domainList",
    component: domainList,
    meta: {
      auth: true, // 用于判断当前路由是否需要登陆
    },
  },
  {
    path: "/examination",
    name: "examination",
    component: examination,
    meta: {
      auth: true, // 用于判断当前路由是否需要登陆
    },
  },
  {
    path: "/result",
    name: "result",
    component: result,
    meta: {
      auth: true, // 用于判断当前路由是否需要登陆
    },
  },
  // 译员服务规则及管理制度
  {
    path: "/ruleManagement",
    name: "ruleManagement",
    component: ruleManagement,
    meta: {
      auth: false, // 用于判断当前路由是否需要登陆
    },
  },
  // 服务协议
  {
    path: "/serviceAgreement",
    name: "serviceAgreement",
    component: serviceAgreement,
  },
  // 法律声明及隐私权政策
  {
    path: "/legalPrivacy",
    name: "legalPrivacy",
    component: legalPrivacy,
  },
  // 联系我们
  {
    path: "/contactUs",
    name: "contactUs",
    component: contactUs,
  },
  // 关于我们
  {
    path: "/about",
    name: "about",
    component: about,
  },
  // 帮助中心
  {
    path: "/helpCenter",
    name: "helpCenter",
    component: helpCenter,
    children: [
      {
        path: "/registerAndLogin",
        name: "registerAndLogin",
        component: registerAndLogin,
      },
      {
        path: "/nameAuthentication",
        name: "nameAuthentication",
        component: nameAuthentication,
      },
      {
        path: "/fillInTheResume",
        name: "fillInTheResume",
        component: fillInTheResume,
      },
      {
        path: "/becomeAnInterpreter",
        name: "becomeAnInterpreter",
        component: becomeAnInterpreter,
      },
      // {
      //   path: "/languageTesting",
      //   name: "languageTesting",
      //   component: languageTesting,
      // },
      // {
      //   path: "/interpreterCategory",
      //   name: "interpreterCategory",
      //   component: interpreterCategory,
      // },
      {
        path: "/interpreterGrade",
        name: "interpreterGrade",
        component: interpreterGrade,
      },
      {
        path: "/getTask",
        name: "getTask",
        component: getTask,
      },
      {
        path: "/missionName",
        name: "missionName",
        component: missionName,
      },
      // {
      //   path: "/manuscript",
      //   name: "manuscript",
      //   component: manuscript,
      // },
      {
        path: "/punishmentStandard",
        name: "punishmentStandard",
        component: punishmentStandard,
      },
      {
        path: "/qualityStandard",
        name: "qualityStandard",
        component: qualityStandard,
      },
      {
        path: "/platformRules",
        name: "platformRules",
        component: platformRules,
      },
      // {
      //   path: "/taskRule",
      //   name: "taskRule",
      //   component: taskRule,
      // },
      {
        path: "/escalationRule",
        name: "escalationRule",
        component: escalationRule,
      },
      {
        path: "/commonProblem",
        name: "commonProblem",
        component: commonProblem,
      },
    ],
  },
];
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// 路由守卫
router.beforeEach((to, from, next) => {
  // to要跳转到的路径
  // from从哪个路径来
  // next往下执行的回调
  let token = cookies.get("token");
  // 判断该页面是否需要登录
  if (to.meta.auth) {
    // 如果token存在直接跳转
    if (token) {
      next();
    } else {
      next({
        path: "/login",
        query: {
          redirect: to.fullPath,
        },
        // 跳转时传递参数到登录页面，以便登录后可以跳转到对应页面
      });
    }
  } else {
    // 如果不需要登录，则直接跳转到对应页面
    next();
  }
});
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default router;
